import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Index from '@/views/fertilizers/Index';
import Content from '@/views/fertilizers/Content';

export default {
  path: 'fertilizers',
  component: Index,
  name: 'fertilizers',
  meta: { title: 'Fertilizers' },
  beforeEnter: multiguard([ middleware.hasPlan, middleware.isNotSuperImpact ]),
  children: [
    {
      path: ':type/'
    },
    {
      path: ':type/:feltId',
      component: Content,
      name: 'Fertilizers',
      meta: { title: 'Fertilizers' },
    },
  ]
};
